export const CheckModalType = {
  Error: "error",
  Success: "success",
  Disenroll: "disenroll",
  BlockingEvent: "blockingEvent",
};
